import { vuexfireMutations, firestoreAction } from "vuexfire";
import { repairsCollection, db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    repairList: [],
    repairProfile: {}
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    callRepairs: context => {
      context.dispatch("bindRepairs");
    },
    bindRepairs: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "repairList",
        repairsCollection
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    }),
    bindARepair: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "repairProfile",
        repairsCollection.doc(id)
      );
    }),
    bindRepairsToSparePart: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "repairList",
        repairsCollection
          .where("sparePartId", "==", id)
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    })
  },
  getters: {}
};
